const setItem = (storageName, data) => {
    if (data === undefined) return;
    localStorage.setItem(storageName, JSON.stringify(data));
};

const getItem = storageName => {
    try {
        return JSON.parse(localStorage.getItem(storageName));
    } catch (e) {
        localStorage.removeItem(storageName);
        return null;
    }
};

const getHideSourceURLKey = appName => {
    return `${appName}-hideSourceURL`;
};

const removeItem = storageName => {
    localStorage.removeItem(storageName);
};

const isKeyPresent = storageName => {
    if (getItem(storageName)) return true;
    return false;
};

const getIsRichWizardKey = appName => {
    return `${appName}_isRichWizard`;
};

const cleanUp = name => {
    localStorage.removeItem(getHideSourceURLKey(name));
    localStorage.removeItem(getIsRichWizardKey(name));
};

const module = {
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    isKeyPresent: isKeyPresent,
    cleanUp: cleanUp,
    getIsRichWizardKey: getIsRichWizardKey
};

export default module;
